/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Determines how the equity value is computed. If you select EQUITY_VALUE, the currencyAmount is the equity value. Otherwise, we will have to account for the valuationInputAdjustments to get the equity value.
 */
export enum ValuationInputType {
    ENTERPRISE_VALUE = 'ENTERPRISE_VALUE',
    EQUITY_VALUE = 'EQUITY_VALUE',
}
